import {MobileState} from "../../interfaces/store/reducers/mobile";
import {SetIsMobileAction} from "../../interfaces/store/actions/mobile";
import {SET_IS_MOBILE} from "../actions/availableActions";
import {MOBILE_WIDTH} from "../../utils/constants";

const initialState: MobileState = {
    isMobile: window.innerWidth <= MOBILE_WIDTH,
};

type AvailableActions = SetIsMobileAction;

const mobileReducer = (state: MobileState = initialState, action: AvailableActions): MobileState => {
    switch (action.type) {
        case SET_IS_MOBILE:
            return {
                isMobile: window.innerWidth <= MOBILE_WIDTH,
            };
        default:
            return state;
    }
};

export default mobileReducer;
